export enum EntityType {
    ACCOUNT = 1,
    CONTACT = 2,
    CHATBOT = 3,
    EXTERNAL = 4,
    ANONYMOUS = 5,
}